"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_UNITS = exports.UNIT_MAP = void 0;
const time_1 = __importDefault(require("../../time"));
exports.UNIT_MAP = {
    [time_1.default.SECOND]: "second",
    [time_1.default.MINUTE]: "minute",
    [time_1.default.HOUR]: "hour",
    [time_1.default.DAY]: "day",
    [time_1.default.WEEK]: "week",
};
exports.DEFAULT_UNITS = [
    time_1.default.WEEK,
    time_1.default.DAY,
    time_1.default.HOUR,
    time_1.default.MINUTE,
    time_1.default.SECOND,
];
function reduceSeconds(value, units = exports.DEFAULT_UNITS) {
    // Find the largest match for the smallest number.
    const unit = units.find((compare) => value >= compare) || time_1.default.SECOND;
    // Scale the value to the unit.
    const scaled = Math.round((value / unit) * 100) / 100;
    return {
        original: value,
        value: value.toString(),
        scaled,
        unit: exports.UNIT_MAP[unit],
    };
}
exports.default = reduceSeconds;
